import { appTitles } from 'features/app/routes';
import { companyTitles } from 'features/company/routes';
import { consultantsTitles } from 'features/consultants/routes';
import { crmTitles } from 'features/crm/routes';
import { devTitles } from 'features/dev/routes';
import { docsTitles } from 'features/docs/routes';
import { partiesTitles } from 'features/parties/routes';
import { posTitles } from 'features/pos/routes';
import { productsTitles } from 'features/products/routes';
import { statsTitles } from 'features/stats/routes';

const DEFAULT_TITLE = 'Панель управления';

/**
 * Each feature owns its own titles; the first matching rule wins, so more
 * specific rules must come before their prefixes inside a feature list.
 */
const TITLES = [
  ...statsTitles,
  ...companyTitles,
  ...devTitles,
  ...consultantsTitles,
  ...docsTitles,
  ...productsTitles,
  ...partiesTitles,
  ...crmTitles,
  ...appTitles,
  ...posTitles,
];

const matches = (rule, path) => {
  if (rule.path) return rule.path === path;
  if (rule.match) return rule.match.test(path);
  if (rule.prefix) return path.startsWith(rule.prefix);
  return false;
};

export const getPageTitle = (pathname) => {
  const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');

  if (path === '/' || path === '/dashboard') return 'Дашборд';

  const rule = TITLES.find((candidate) => matches(candidate, path));

  return rule ? rule.title : DEFAULT_TITLE;
};
